import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ISelectOption} from '../single-select/single-select.component';
import {LoggerService} from '../../../logging/services/logger.service';
import {LogLevel} from '../../../logging/data/logLevel';
import {LogSourceType} from '../../../logging/data/logSourceType';
import {LogSource} from '../../../logging/data/logSource';

@Component({
  selector: 'w-carrier-single-select',
  templateUrl: './carrier-single-select.component.html',
  styleUrls: ['./carrier-single-select.component.scss']
})
export class CarrierSingleSelectComponent implements OnInit, OnChanges {
  @Input() value: 'USPS' | 'FEDEX' | 'UPS' | 'DHL' | 'Drop Off' | string;
  @Input() showOtherCarriers: boolean = true;
  @Input() label: string;
  @Input() hideLabel: boolean = false;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  initialOption: ISelectOption;
  options: ISelectOption[];

  constructor(private loggingService: LoggerService) {
    this.options = [
      {name: '', value: 'USPS', icon: 'fab fa-usps', color: undefined},
      {name: '', value: 'FEDEX', icon: 'fab fa-fedex', color: undefined},
      {name: '', value: 'UPS', icon: 'fab fa-ups', color: undefined},
      {name: '', value: 'DHL', icon: 'fab fa-dhl', color: undefined},
      {name: '', value: 'Drop Off', icon: 'fas fa-inbox', color: undefined},
    ];
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.value = changes.value.currentValue;
    this.initialOption = this.options.find(x => x.value === this.value);
    if (!this.showOtherCarriers) {
      const newOptions: ISelectOption[] = [];
      newOptions.push(this.initialOption);
      this.options = newOptions;
    }
  }


  onValueChange($event: ISelectOption) {
    this.valueChange.emit($event.value);
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.COMPONENT, LogSource.CarrierSingleSelectFieldComponent, 'Selected carrier: ' + $event.value);
  }
}
